import './assets/app.css'
import './stores/historial';
import App from './App.svelte'

const app = new App({
  target: document.getElementById('app'),
})

export default app
